import { useQuery } from '@tanstack/react-query';
import { listContainers } from '@/services/api/endpoints';
import type { Container } from '@/types/domain';

export function useContainers() {
  return useQuery<Container[]>({
    queryKey: ['containers'],
    queryFn: listContainers,
    staleTime: 60_000,
    // Token acquisition (NAA) can fail transiently on the first brokered
    // attempt; give it a couple of automatic retries before surfacing the
    // error + manual Réessayer button.
    retry: 2,
  });
}
